<template>
  <div class="visit-absence">
    <div class="bg-white p-3 pr-md-4">
      <section-title
        class="visit-absence__section-title"
        container-class="visit-absence__section-title__container"
        icon="fas fa-user-cog"
        title="Ausencia de Admisión"
        title-class="visit-absence__section-title__info"
      />

      <validation-observer ref="visitAbsence">
        <div class="row ml-md-4">
          <div class="col-12 col-md-2 mb-md-4 mb-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-date-picker
                v-model="absence.date"
                custom-error-msg="La fecha de la ausencia es requerida."
                :error="errors[0]"
                label="Fecha de la ausencia:"
                :max-date="new Date()"
                :min-date="data.linkedDate"
                placeholder="DD/MM/YYYY"
              />
            </validation-provider>
          </div>
          <div class="col-12 col-md-6 pl-md-5 mb-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="absence.reason"
                class="dropdown"
                :clearable="false"
                custom-error-msg="La razón de la ausencia es requerida."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Razón de ausencia:"
                :options="data.reasons"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div v-if="!disabledFormControl" class="col-12 col-md-4 mb-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="absence.reasonOther"
                custom-error-msg="El campo de Otros es requerido."
                :error="errors[0]"
                label="(Otro) Especifique:"
                type="text"
              />
            </validation-provider>
          </div>
          <div class="col-12 mb-2">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                id="comment"
                v-model="absence.comment"
                class="visit-absence__text-area"
                :count-classes="['d-block', 'small-counter']"
                custom-error-msg="El comentario es requerido."
                :error="errors[0]"
                label="Comentario:"
                :maxlength="3000"
                name="comment"
                show-char-count
              />
            </validation-provider>
          </div>
          <div class="col-12 d-flex justify-content-end">
            <action-button
              i="fas fa-times-circle"
              text="Cancelar"
              variant="outline-danger mr-3"
              @click="dispose"
            />

            <action-button
              i="fa fa-save"
              text="Guardar"
              variant="success"
              @click="save"
            />
          </div>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import CustomDatePicker from 'custom-date-picker';
import absenceReason from '@/utils/shared/constants/absenceReason';

export default {
  name: 'VisitAbsence',
  components: {
    SectionTitle,
    CustomTextArea,
    ActionButton,
    CustomDropDown,
    CustomInput,
    CustomDatePicker,
  },
  props: {
    dispose: {
      type: Function,
      default: function() {
        return () => {};
      },
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    absence: {
      date: null,
      reason: null,
      comment: null,
      reasonOther: null,
    },
  }),
  computed: {
    disabledFormControl() {
      return this.absence.reason?.id != absenceReason.Other;
    },
  },
  watch: {
    data: {
      inmediate: true,
      handler(current) {
        if (current) {
          const absence = current;
          this.absence = { ...absence };
        }
      },
    },
  },
  methods: {
    async save() {
      const isValid = await this.$refs.visitAbsence.validate();
      if (!isValid) return;

      let params = {
        ...this.absence,
        reasonId: this.absence.reason.id,
      };
      delete params.reason;
      this.$emit('save', params);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.visit-absence {
  padding: 0.5rem 0.5rem;

  ::v-deep &__text-area {
    .small-counter {
      font-size: 0.8rem;
      color: map-get($colors, 'gray-6');
    }
  }

  ::v-deep &__section-title {
    margin-bottom: 1rem;

    &__container {
      background: none;
      display: flex;
      align-items: center;

      .title-icon {
        font-size: 14px;
        color: map-get($colors, 'orange');
      }

      .dot {
        background-color: map-get($colors, 'white');
        width: 30px;
        height: 30px;
      }
    }

    &__info {
      font-size: 1rem;
      padding-left: 3px !important;
      color: map-get($colors, 'gray-7') !important;
    }

    @media screen and (min-width: 768px) {
      padding-left: 0px !important;
    }
  }
}
</style>
